import axios, { AxiosRequestConfig, AxiosPromise, CancelToken } from 'axios';
import { injectable } from '@servicetitan/react-ioc';
import { makeCodedException } from 'utils';

@injectable()
export class FeBundleApi {
    getPackageUrl(isPilot: boolean, isLegacy: boolean, cancelToken?: CancelToken): AxiosPromise<string> {
        const url = 'fe-bundle/package-url?pilot=' + isPilot + '&legacy=' + isLegacy;

        const options = <AxiosRequestConfig>{
            baseURL: '',
            cancelToken,
            url,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(axios.request<string>(options));
    }
}
